import { Injectable, inject, signal } from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {AuthService} from './auth.service';
import {map, take, tap} from 'rxjs/operators';
import {Location} from '@angular/common';
import {Logger} from '../utils/logger';
import {CommonUtil} from '../utils/common.util';
import {FirebaseApi} from './firebase-api.service';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  private auth = inject(AuthService);
  private firebaseApi = inject(FirebaseApi);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private location = inject(Location);

  /** Signal-based loader flag – replaces the old Subject for zone-independent reactivity */
  readonly loader = signal(true);

  /** @deprecated Use `loader` signal instead. Kept for backward compat with existing subscriptions. */
  public loader$ = new Subject<boolean>();

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    Logger.log('canActivate AuthGuardService', next);
    this.loader.set(true);
    this.loader$.next(true);
    return this.auth.currentUserObservable.pipe(
      take(1),
      map((user: firebase.User) => {
        if (user) {
          this.firebaseApi.currentUser = user;
        }
        return !!user && user.emailVerified;
      }),
      tap(loggedIn => {
        Logger.log('loggedIn: ', loggedIn, this.location.path());
        if (!loggedIn && !CommonUtil.inIframe()) {
          Logger.log('access denied');
          this.router.navigate(['/login'], {queryParams: {rdt: state.url}});
        }
        this.loader.set(false);
        this.loader$.next(false);
      })
    );
  }
}
